import React from 'react';
import MotorApp from './components/MotorApp';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import fnolTheme from '@fnol/library/src/themes/fnolTheme';

// returns MotorApp (the app entry file) and providers

function App() {
    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={fnolTheme}>
                <MotorApp />
            </ThemeProvider>
        </>
    );
}

export default App;
